import React from "react";

const BootCursor = (props) => {
  const { noWrapper } = props;
  const cursorEl = <span className="boot-cursor" />;
  return noWrapper ? cursorEl : <div className="boot-term">{cursorEl}</div>;
};

export default BootCursor;
